import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectEvent } from '../../reducers/events';
import { toggleCheckbox, setYearViewDate } from '../../reducers/yearView';

import EventDetailsContent from '../eventDetails/EventDetailsContent.jsx';
import EventListContent from './EventListContent.jsx';

import '../css/EventDetails.css';
import '../css/EventList.css';

const mapStateToProps = state => ({
  event: getSelectedEvent(state.events),
  isChecked: state.yearview.isChecked,
  yearViewDate: state.yearview.yearViewDate
});

const mapDispatchToProps = dispatch => ({
  closeEvent: () => dispatch(selectEvent()),
  changeYearViewDate: yearViewDate => dispatch(setYearViewDate(yearViewDate)),
  toggleCheckbox: isChecked => dispatch(toggleCheckbox(isChecked))
});

function getSelectedEvent({ allEvents, selectedEvent }) {
  return (selectedEvent) ? allEvents.find(event => event.EVENT_ID === selectedEvent) : undefined;
}

const MapEvents = (props) => {
  const event = props.event;

  if (!event) {
    return (
      <div className="event-list">
        <EventListContent
          mapEvents={props.mapEvents}
          selectedBbox={props.selectedBbox}
          changeMapView={props.changeMapView}
          isChecked={props.isChecked}
          toggleCheckbox={props.toggleCheckbox}
          yearViewDate={props.yearViewDate}
          changeYearViewDate={props.changeYearViewDate}
        />
      </div>
    );
  }

  return (
    <div className="event-details">
      <button type="button" className="close" aria-label="Close" onClick={props.closeEvent}>
        <span aria-hidden="true">&times;</span>
      </button>

      <EventDetailsContent event={event} />
    </div>
  );
};


MapEvents.defaultProps = {
  event: undefined
};

MapEvents.propTypes = {
  changeMapView: PropTypes.func.isRequired,
  changeYearViewDate: PropTypes.func.isRequired,
  closeEvent: PropTypes.func.isRequired,
  event: PropTypes.object,
  isChecked: PropTypes.bool.isRequired,
  mapEvents: PropTypes.array.isRequired,
  selectedBbox: PropTypes.object.isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
  yearViewDate: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(MapEvents);



// WEBPACK FOOTER //
// ./src/components/eventDetails/MapEvents.jsx